import { AuthConfig } from "angular-oauth2-oidc";


// env.jsから値を取得するための準備
const browserWindow = window || {};
const browserWindowEnv = browserWindow['__env'] || {};

// 環境変数 env.js から取得（env.jsのimportはindex.htmlでやってるよ）
export const environment = {
  production: browserWindowEnv['IS_PRODUCTION'],
  SHARED_API_BASE_PATH: browserWindowEnv['SHARED_API_BASE_PATH'],
  BILL_API_BASE_PATH: browserWindowEnv['BILL_API_BASE_PATH'],
  EEC_API_BASE_PATH: browserWindowEnv['EEC_API_BASE_PATH'],
  FF_API_BASE_PATH: browserWindowEnv['FF_API_BASE_PATH'],
  PROV_API_BASE_PATH: browserWindowEnv['PROV_API_BASE_PATH'],
  ACEPTBASE_UI_BASE_PATH: browserWindowEnv['ACEPTBASE_UI_BASE_PATH'],
  AUTH_ISSURE: browserWindowEnv['AUTH_ISSURE'],
  AUTH_REDIRECT_URI: browserWindowEnv['AUTH_REDIRECT_URI'],
  AUTH_CLIENT_ID: browserWindowEnv['AUTH_CLIENT_ID'],
  AUTH_RESPONSE_TYPE: browserWindowEnv['AUTH_RESPONSE_TYPE'],
  AUTH_LOGIN_URL: browserWindowEnv['AUTH_LOGIN_URL'],
  AUTH_LOGOUT_URL: browserWindowEnv['AUTH_LOGOUT_URL'],
  AUTH_SCOPE: browserWindowEnv['AUTH_SCOPE'],
  AUTH_STRICT_DISCOVERY_DOCUMENT_VALIDATION: browserWindowEnv['AUTH_STRICT_DISCOVERY_DOCUMENT_VALIDATION'],
  AUTH_SHOW_DEBUG_INFOMATION: browserWindowEnv['AUTH_SHOW_DEBUG_INFOMATION'],
  HTTP_TIMEOUT: browserWindowEnv['HTTP_TIMEOUT'],
};

// 認証ライブラリ設定クラス
export const authCodeFlowConfig: AuthConfig = {
  // 認証サービスのURL
  issuer: environment.AUTH_ISSURE,
  // ログイン後にリダイレクトするURL
  redirectUri: environment.AUTH_REDIRECT_URI,
  // クライアントID（oidc認証方式参照）
  clientId: environment.AUTH_CLIENT_ID,
  // レスポンスタイプ（oidc認証方式参照）
  responseType: environment.AUTH_RESPONSE_TYPE,
  // 認証サービスのログインエンドポイント
  loginUrl: environment.AUTH_LOGIN_URL,
  // 認証サービスのログアウトエンドポイント
  logoutUrl: environment.AUTH_LOGOUT_URL,
  // スコープ（oidc認証方式参照）
  scope: environment.AUTH_SCOPE,
  // 「loginUrl」とかがissureのURLと同じかのValidate実行要否
  strictDiscoveryDocumentValidation: environment.AUTH_STRICT_DISCOVERY_DOCUMENT_VALIDATION,
  // debug表示
  showDebugInformation: environment.AUTH_SHOW_DEBUG_INFOMATION,
}

// リクエストにBeararヘッダをつける対象のURL
export const authInterceptTargetUrl: string[] =
  [
    environment.SHARED_API_BASE_PATH + '.+',
    environment.BILL_API_BASE_PATH + '.+',
    environment.EEC_API_BASE_PATH + '.+',
    environment.FF_API_BASE_PATH + '.+',
    environment.PROV_API_BASE_PATH + '.+',
  ]
